/// <reference path="../../../NoboxChat/Chatrooms/ChatroomsGrid.ts" />

namespace Nobox {

    import fld = ChatroomsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class LinkConversationGrid extends ChatroomsGrid {
        protected getDialogType() { return ChatroomsDialog; }
        protected getColumnsKey() { return LinkConversationColumns.columnsKey; }

        constructor(container: JQuery) {
            super(container);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ ContactId: this.contactId });
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let listChannel = Q.getLookup("Nobox.ChannelAutomationLookup").itemById as unknown as Master.ChannelRow[];
            let listAccount = Q.getLookup("Nobox.AccountLookup").itemById as unknown as Nobox.AccountRow[];

            //columns.unshift({
            //    field: 'Change Bot Status',
            //    name: '',
            //    format: ctx => {
            //        return '<a href="javascript:;" title="Go to conversation"><i class="fa fa-share text-primary room-link"></i></a>';
            //    },
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});
            Q.first(columns, x => x.field == ChatroomsRow.Fields.ChId).format =
                ctx => `${Q.htmlEncode(listChannel[ctx.value] == undefined ? "-" : listChannel[ctx.value].Nm)}`;
            Q.first(columns, x => x.field == ChatroomsRow.Fields.ChAccId).format =
                ctx => {
                    return `${Q.htmlEncode(listAccount[ctx.value] == undefined ? "-" : listAccount[ctx.value].Name)}`
                };

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            //if (target.hasClass("room-link")) {
            //    window.open("/Chat/Inbox?RoomId=" + item.Id);
            //} 
        }

        protected getButtons() {
            var btn = super.getButtons();
            btn.splice(0, 1);
            return btn;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.contactId;
        }

        private _ContactID: string;

        get contactId() {
            return this._ContactID;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as ChatroomsListRequest;
            //request.ColumnSelection = 1;
            request.Room = true;
            request.EqualityFilter = { CtId: this.contactId };
        }
        set contactId(value: string) {
            if (this._ContactID !== value) {
                this._ContactID = value;
                this.refresh();
            }
        }
    }
}